<template>
  <h-msg-box
    v-model="msgBoxShow"
    width="900"
    class="financial-competition-modal"
    :footerHide="true"
    top="30"
    @on-close="handleMsgBoxClose"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="ranking-list-title">排行榜</span>
    </p>
    <div class="ranking-list-main">
      <h-table
        :row-class-name="rowClassName"
        height="400"
        stripe
        :columns="columns"
        :data="dataList"
        :loading="showLoading"
        noDataHeight="525"
      >
        <div class="no-data" slot="nodata">
          <img src="~@/assets/competition/nodata@2x.png" alt="" />
          <div>
            {{ levelState === '0' ? '赛事暂未开启敬请关注' : ''
            }}{{ levelState === '1' ? '暂无数据' : '' }}
          </div>
        </div>
      </h-table>
      <div class="table-moske" v-if="levelState === '2'">
        <img
          alt="chart-compete-finish"
          src="~@/assets/financialCompetition/chart-compete-finish-2x.png"
        />
      </div>
    </div>
  </h-msg-box>
</template>

<script>
import Api from '@/api/competition/financialIndex'
import { createColumns } from './config'
export default {
  name: 'rankingList',
  props: {
    show: Boolean
  },
  data() {
    return {
      msgBoxShow: false,
      dataList: [],
      showLoading: false,
      levelState: '1', // 当前关卡状态
      columns: createColumns(this)
    }
  },
  created() {
    this.msgBoxShow = this.show
  },
  methods: {
    // 获取排行榜
    async getRankList() {
      this.showLoading = true
      const { team_ranks, team_rank, level_state } = await Api.ranks()
      this.showLoading = false
      this.levelState = level_state
      if (team_ranks && team_ranks.length) {
        if (team_rank) {
          team_ranks.unshift(team_rank) // 如果当前账号也有相应的信息，那么放到第一条
        }
        this.dataList = team_ranks
      } else {
        this.dataList = []
      }
    },
    // 设置行样式
    rowClassName(row, index) {
      // 当前用户设置高亮
      if (row.isSelf) {
        return 'hight-light-row'
      }
      return ''
    },
    handleMsgBoxClose() {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show(newValue) {
      this.msgBoxShow = newValue
      if (this.msgBoxShow) {
        this.getRankList()
      }
    }
  }
}
</script>

<style lang="scss">
.ranking-list-title {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.ranking-list-main {
  width: 100%;
  margin-top: -8px;
  margin-bottom: 8px;
  position: relative;
  .h-table-body,
  .h-table-tip {
    overflow-x: hidden;
  }
  .h-table-row {
    height: 50px;
  }
  .hight-light-row td {
    background-color: #fdf7ec !important;
  }

  .table-moske {
    height: 100%;
    width: 100%;
    background: #fff;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 214px;
      height: 184px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
.compete-is-over {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5)
    url('~@/assets/competition/chart-compete-finish-2x.png') center/214px 184px
    no-repeat;
  z-index: 1;
  left: 0;
  top: 0;
}
.round-wrap {
  position: absolute;
  width: 34px;
  left: 0;
  top: 0;
  div {
    height: 89px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid rgba(217, 217, 217, 1);
    cursor: pointer;
  }
  .active {
    background: #282828;
    color: #fff;
  }
}
.no-data {
  width: 328px;
  margin: 0 auto;
  img {
    width: 328px;
    height: 184px;
  }
  div {
    height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #333;
    text-align: center;
    font-weight: 500;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/rankingList/rankingList.vue